function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#water_view_svg__clip0_1_55)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.892 0a8 8 0 10.217 16 8 8 0 00-.217-16zm.192 14.172a6.173 6.173 0 11-.167-12.344 6.173 6.173 0 01.167 12.344zm1.534-6.333l-.072-.151-.073.15c-.593 1.238-2.354 1.238-2.947 0l-.073-.15-.072.15c-.593 1.238-2.354 1.238-2.948 0l-.072-.15s-.285.37-.604.852a5.274 5.274 0 0010.479.01c-.32-.492-.598-.862-.598-.862l-.072.15c-.594 1.238-2.355 1.238-2.948 0z",
  fill: "currentColor"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "water_view_svg__clip0_1_55"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));
function SvgWaterView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgWaterView;